import { theme } from '@agilize/components-core';
import { device } from '../tools/breakpoints.styles';

export const genericShared = () => `
  address,
  h1, h2, h3, h4, h5, h6,
  blockquote, p, pre,
  dl, ol, ul,
  figure,
  hr,
  table,
  fieldset {
    margin-bottom: 1.3rem;
  }

  dd, ol, ul {
    margin-left: 1rem;
  }
  
  :root { font-family: ${theme.global.defaultFont} }
  @supports (font-variation-settings: normal) {
    :root { font-family: 'Inter var', sans-serif; }
  }

  html {
   font-size: 62.5%;
   scroll-behavior: smooth;
  }

  body {
    font-size: 1.6rem;
    font-weight: normal;
    background-color:  ${theme.colors.grey100};
    text-rendering: optimizeLegibility;
  }

  amp-img {
    display: inline-block;
    align-self: flex-start;

    img {
        object-fit: contain;
    }
  }

  .container {
    margin: 0 auto;
    width: 100%;
    max-width: ${theme.breakpoints[2]};

    ${device.mobile} {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  a {
    color: ${theme.colors.blue700};
    text-decoration: none;
    font-size: 1.2rem;
  }

  .agilize-table {
    width: 100%;

    &__thead th {
      border: none;
      padding: ${theme.global.gutterSpace}px;
      color: ${theme.colors.grey700};
      font-size: ${theme.fontSizes[1]};
    }

    &__tbody {
      box-shadow: 0 0 0 1px ${theme.colors.grey900};
      border-radius: ${theme.global.gutterSpace / 2}px;

      tr:first-child td {
        border-top: none;
      }

      tr:not(first-child) td {
        border-top: 1px solid ${theme.colors.grey100};
        padding:${theme.global.gutterSpace * 1.5}px ${theme.global.gutterSpace * 3.2}px;
        font-weight: 400;
        font-size: ${theme.fontSizes[2]};
        line-height: 17px;
        color: ${theme.colors.grey700};
      }
      
      td:not(.table-col-align--left){
        text-align: center;
      }
    }
  }
`;
